import { FormattedMessage } from 'react-intl';
import { type JSX } from 'react/jsx-runtime';

export const marketplaceAppsLabel: JSX.Element = (
	<FormattedMessage
		id="app-switcher-discovery-section.atlassian-store"
		description="Button indicating that clicking on it will navigate to Marketplace apps"
		defaultMessage="Marketplace apps"
	/>
);

export const STORE_PROD_URL = 'https://marketplace-store.atlassian.com';
export const STORE_STG_URL = 'https://store.stg.atlassian.com';

export const STAGING_ENVS: Set<string> = new Set(['staging']);

export const getStoreUrl = (
	currentEnv: string,
	orgId?: string,
	cloudId?: string,
	product?: string,
): string => {
	let storeUrl = STAGING_ENVS.has(currentEnv) ? STORE_STG_URL : STORE_PROD_URL;

	if (orgId) {
		storeUrl = `${storeUrl}/o/${orgId}`;
	}

	const queryParams: string[] = [];

	if (cloudId) {
		queryParams.push(`cloudId=${cloudId}`);
	}

	if (product && typeof window !== 'undefined') {
		try {
			const sourceUrl = new URL(`${window.location.origin}${window.location.pathname}`);
			sourceUrl.searchParams.set('source_product', product);
			sourceUrl.searchParams.set('entry_point', 'app_switcher');
			queryParams.push(`source=${encodeURIComponent(sourceUrl.toString())}`);
		} catch (e) {
			// ignore URL parsing errors
		}
	}

	if (queryParams.length > 0) {
		storeUrl = `${storeUrl}?${queryParams.join('&')}`;
	}

	return storeUrl;
};

export const AtlassianStoreIcon = (): JSX.Element => (
	<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z"
			fill="#DDDEE1"
		/>
		<path
			d="M5 9L6.5 5H18.5L20 9C20 9.3283 19.9353 9.65339 19.8097 9.95671C19.6841 10.26 19.4999 10.5356 19.2678 10.7678C19.0356 10.9999 18.76 11.1841 18.4567 11.3097C18.1534 11.4353 17.8283 11.5 17.5 11.5C17.1717 11.5 16.8466 11.4353 16.5433 11.3097C16.24 11.1841 15.9644 10.9999 15.7322 10.7678C15.5001 10.5356 15.3159 10.26 15.1903 9.95671C15.0647 9.65339 15 9.3283 15 9C15 9.3283 14.9353 9.65339 14.8097 9.95671C14.6841 10.26 14.4999 10.5356 14.2678 10.7678C14.0356 10.9999 13.76 11.1841 13.4567 11.3097C13.1534 11.4353 12.8283 11.5 12.5 11.5C12.1717 11.5 11.8466 11.4353 11.5433 11.3097C11.24 11.1841 10.9644 10.9999 10.7322 10.7678C10.5001 10.5356 10.3159 10.26 10.1903 9.95671C10.0647 9.65339 10 9.3283 10 9C10 9.3283 9.93534 9.65339 9.8097 9.95671C9.68406 10.26 9.49991 10.5356 9.26777 10.7678C9.03562 10.9999 8.76002 11.1841 8.45671 11.3097C8.15339 11.4353 7.8283 11.5 7.5 11.5C7.1717 11.5 6.84661 11.4353 6.54329 11.3097C6.23998 11.1841 5.96438 10.9999 5.73223 10.7678C5.50009 10.5356 5.31594 10.26 5.1903 9.95671C5.06466 9.65339 5 9.3283 5 9Z"
			fill="#101214"
		/>
		<path
			d="M9.03073 12.6956C9.3799 12.5509 9.70612 12.3579 10 12.1226C10.2939 12.3579 10.6201 12.5509 10.9693 12.6956C11.4546 12.8966 11.9747 13.0001 12.5 13.0001C13.0253 13.0001 13.5454 12.8966 14.0307 12.6956C14.3799 12.5509 14.7061 12.3579 15 12.1226C15.2939 12.3579 15.6201 12.5509 15.9693 12.6956C16.4546 12.8966 16.9747 13.0001 17.5 13.0001C17.8381 13.0001 18.1741 12.9572 18.5 12.873V19.0001H14.5V14.5001H10.5V19.0001H6.5V12.873C6.82592 12.9572 7.1619 13.0001 7.5 13.0001C8.02529 13.0001 8.54543 12.8966 9.03073 12.6956Z"
			fill="#101214"
		/>
	</svg>
);
